import Parse from 'parse'

const state = {
  tourFinished: false
}

const getters = {
  tourFinished: state => state.tourFinished
}

const actions = {
  toggleTour ({ commit }, payload) {
    commit('setTour', payload)
    /** Save only when its true */
    if (payload) {
      const user = Parse.User.current()
      user.set('tourFinished', true)
      user.save()
    }
  }
}

const mutations = {
  setTour: (state, tourFinished) => (state.tourFinished = tourFinished)
}

export default {
  state,
  getters,
  actions,
  mutations
}
